module.exports = __webpack_public_path__ + "f41a976947eff394c6e4a7bcde52a4ea.svg";